/* AST device compare (2026-10-20). Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ast-cmp]');
  if (!root) return;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  function readJSON(id, fb) { try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return fb; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function icon(name) { var t = $('template[data-ast-icon="' + name + '"]'); return t ? t.innerHTML : ''; }

  var MAX = 4;
  var mqPhone = window.matchMedia('(max-width: 749px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Data ---------- */
  var BRANDS = { 'PAX': 'PAX', 'INGENICO': 'Ingenico', 'VERIFONE': 'Verifone', 'DEJAVOO': 'Dejavoo', 'VALOR': 'Valor', 'CASTLE TECHNOLOGY': 'Castles',
    'SUNMI': 'SUNMI', 'ID TECH': 'ID TECH', 'CARD FLIGHT': 'CardFlight', 'POYNT': 'Poynt', 'EQUINOX': 'Equinox', 'FIRST DATA': 'First Data',
    'NEXGO': 'NEXGO', 'AMP': 'AMP', 'KAYANA': 'Kayana' };
  var BRAND_ORDER = ['PAX', 'Ingenico', 'Verifone', 'Dejavoo', 'Valor', 'Castles', 'SUNMI', 'ID TECH', 'Equinox', 'Poynt', 'First Data', 'NEXGO', 'AMP', 'CardFlight', 'AnywhereCommerce'];
  var TYPES = [['countertop', 'Countertop'], ['wireless', 'Wireless'], ['pinpad', 'PIN pad'], ['multilane', 'Multilane'], ['unattended', 'Unattended'], ['cardreader', 'Card reader']];

  var raw = readJSON('ast-cmp-index', []);
  var presets = readJSON('ast-cmp-presets', []);
  var pci = readJSON('ast-compare-pci', { d: {} });
  var byH = {};
  var items = raw.map(function (it) {
    var tags = (it.tg || '').split('|');
    var brand = BRANDS[(it.v || '').toUpperCase()];
    if (!brand) {
      if (tags.indexOf('sunmi') > -1 || /^sunmi/i.test(it.m)) brand = 'SUNMI';
      else if (/^anywhere-commerce/.test(it.h)) brand = 'AnywhereCommerce';
      else brand = (it.v || '').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    var types = TYPES.filter(function (t) { return tags.indexOf(t[0]) > -1; }).map(function (t) { return t[0]; });
    var model = it.m || '';
    var short = model;
    [brand, 'Castles', 'Ingenico', 'Nexgo', 'First Data', 'ID TECH', 'CardFlight', 'Valor'].forEach(function (b) {
      var re = new RegExp('^' + b.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s+', 'i');
      if (re.test(short)) short = short.replace(re, '');
    });
    var o = {
      h: it.h, model: model, short: short, brand: brand, types: types, tags: tags, price: it.p, varies: it.pv, avail: it.a,
      img: it.i, url: it.u, notable: it.n, limited: it.r === 0, refurb: tags.indexOf('refurbished') > -1 || /refurb/i.test(it.h), sunmi: brand === 'SUNMI'
    };
    o.q = (brand + ' ' + model + ' ' + short + ' ' + it.h.replace(/-/g, ' ')).toLowerCase();
    byH[o.h] = o;
    return o;
  }).sort(function (a, b) {
    var ai = BRAND_ORDER.indexOf(a.brand), bi = BRAND_ORDER.indexOf(b.brand);
    ai = ai < 0 ? 99 : ai; bi = bi < 0 ? 99 : bi;
    return ai - bi || (a.refurb - b.refurb) || a.short.localeCompare(b.short, undefined, { numeric: true });
  });
  // Same model sold as more than one listing: label the version from the handle.
  var VARIANT = [[/wifi-only/, 'Wi-Fi only'], [/(^|-)4g(-|$)/, '4G'], [/(^|-)3g(-|$)/, '3G'], [/deluxe/, 'Deluxe'], [/standard/, 'Standard'],
    [/usaepay/, 'USAePay'], [/accept-blue/, 'Accept Blue'], [/with-base/, 'With base'], [/^p3302/, 'P3302, 4G'], [/^p3303/, 'P3303, Wi-Fi']];
  var groups = {};
  items.forEach(function (it) { var k = it.model + '|' + it.refurb; (groups[k] = groups[k] || []).push(it); });
  Object.keys(groups).forEach(function (k) {
    var g = groups[k]; if (g.length < 2) return;
    g.forEach(function (it) { var m = VARIANT.filter(function (v) { return v[0].test(it.h); })[0]; it.variant = m ? m[1] : ''; });
    var any4g = g.some(function (it) { return it.variant === '4G'; });
    g.forEach(function (it) { if (!it.variant && any4g) it.variant = 'Wi-Fi'; if (it.variant) it.short += ' (' + it.variant + ')', it.model += ' (' + it.variant + ')'; });
  });
  presets = presets.map(function (p) { p.h = (p.h || []).filter(function (h) { return byH[h]; }); return p; }).filter(function (p) { return p.h.length > 1; });

  var money = function (cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var typeLabel = function (it) {
    var l = it.types.map(function (t) { return TYPES.filter(function (x) { return x[0] === t; })[0][1]; });
    if (l.indexOf('PIN pad') > -1 || l.indexOf('Multilane') > -1 || l.indexOf('Unattended') > -1) l = l.filter(function (x) { return x !== 'Countertop'; });
    return l.slice(0, 2).join(' / ') || 'Smart POS';
  };

  /* ---------- Spec loading ---------- */
  var specs = {};
  var ALIAS = { 'Comms / Interfaces': 'Comms', 'Camera / Scanner': 'Cameras / Scanner', 'Battery / Power': 'Battery', 'Processor / Memory / OS': 'Processor' };
  function load(h) {
    if (specs[h] && specs[h].state !== 'error') return specs[h].p;
    var rec = specs[h] = { state: 'loading' };
    var cacheKey = 'ast-spec:' + h;
    try { var c = sessionStorage.getItem(cacheKey); if (c) { set(rec, JSON.parse(c)); rec.p = Promise.resolve(); return rec.p; } } catch (e) {}
    var url = (byH[h] ? byH[h].url : '/products/' + h).split('?')[0] + '?section_id=ast-compare-spec';
    rec.p = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var m = html.match(/<script[^>]*data-ast-spec[^>]*>([\s\S]*?)<\/script>/);
      if (!m) throw new Error('no data');
      var d = JSON.parse(m[1]);
      set(rec, d);
      try { sessionStorage.setItem(cacheKey, JSON.stringify(d)); } catch (e) {}
    }).catch(function () { rec.state = 'error'; }).then(render);
    return rec.p;
  }
  function set(rec, d) {
    var rows = {}, raw = (d.s && d.s.rows) || [];
    raw.forEach(function (r) { rows[ALIAS[r.label] || r.label] = r.value; if (r.label === 'Processor / Memory / OS') rows._combined = true; });
    rec.rows = rows; rec.pdf = d.pdf; rec.src = d.s && d.s.source_url; rec.state = 'ok';
    rec.all = raw.map(function (r) { return r.value; }).join(' \n ');
  }

  /* ---------- Feature detection (conservative: only explicit text) ---------- */
  var NEG = /^\s*(none|no\b|n\/?a\b|not (included|available|supported|applicable))/i;
  var FEATS = {
    chip: { label: 'Chip', rows: ['Card Readers'], re: /EMV|chip|ICC|smart ?card|contact(?!less)|7816|\bdip\b/i, onlyYes: true },
    swipe: { label: 'Swipe', rows: ['Card Readers'], re: /magnetic|mag ?stripe|\bMSR\b|swipe|track/i, onlyYes: true },
    tap: { label: 'Tap', rows: ['Card Readers'], re: /contactless|NFC|CTLS|\btap\b/i, onlyYes: true, claim: /contactless|\bnfc\b|ctls/ },
    lte: { label: '4G / LTE', rows: ['Comms'], re: /\b(4G|LTE|5G|3G|cellular|GPRS)\b/i, claim: /\b(4g|lte|5g)\b/ },
    wifi: { label: 'Wi-Fi', rows: ['Comms'], re: /wi-?fi|802\.11|WLAN/i, claim: /wi ?fi\b|wifi/ },
    bt: { label: 'Bluetooth', rows: ['Comms'], re: /bluetooth|\bBLE\b|\bBT\b/i, claim: /bluetooth|\bbt\b/ },
    eth: { label: 'Ethernet', rows: ['Comms', 'Ports'], re: /ethernet|\bLAN\b|RJ-?45/i, claim: /ethernet|\blan\b|\bip\b/ },
    printer: { label: 'Printer', rows: ['Printer'], re: /./ , absentUnknown: true },
    scan: { label: 'Camera / scanner', rows: ['Cameras / Scanner'], re: /scan|barcode|QR|camera|\d\s?MP\b/i },
    battery: { label: 'Battery', rows: ['Battery'], re: /./, absentUnknown: true },
    android: { label: 'Android', rows: ['Operating System', 'Processor'], re: /android/i, claim: /android/ }
  };
  // Yes: the spec sheet or our own listing (handle/tags) says so. No: only when the sheet says "None".
  // Anything else is "not listed": manufacturer sheets often leave features out.
  function feat(sp, key, it) {
    var f = FEATS[key];
    var claimed = f.claim && it && f.claim.test((it.h.replace(/-/g, ' ') + ' ' + it.tags.join(' ')).toLowerCase());
    var vals = f.rows.map(function (r) { return sp.rows[r]; }).filter(Boolean);
    if (!vals.length) return claimed ? 'yes' : 'unk';
    if (vals.every(function (v) { return NEG.test(v); })) return 'no';
    var segs = [];
    vals.forEach(function (v) { v.split(/\n|\s\|\s|;\s/).forEach(function (s) { if (f.re.test(s)) segs.push(s); }); });
    if (!segs.length) return claimed ? 'yes' : 'unk';
    if (segs.every(function (s) { return /optional|option\b/i.test(s); })) return 'opt';
    return 'yes';
  }

  /* ---------- Row model ---------- */
  var LABELS = { 'Operating System': 'Operating system', 'Keys / Buttons': 'Keys and buttons', 'Card Readers': 'Card readers', 'Comms': 'Communications', 'SIM / SAM': 'SIM and SAM slots', 'Cameras / Scanner': 'Camera and scanner', 'Adapter / Power': 'Power adapter' };
  var GROUPS = [
    { id: 'glance', title: 'At a glance', rows: [
      { k: 'price', label: 'Listed price', hint: 'Single unit, web price', fn: priceCell, needs: false },
      { k: 'type', label: 'Device type', fn: function (it) { return txt(typeLabel(it)); }, needs: false },
      { k: 'pay', label: 'Ways to pay', feats: ['chip', 'swipe', 'tap'] },
      { k: 'conn', label: 'Connectivity', feats: ['lte', 'wifi', 'bt', 'eth'] },
      { k: 'built', label: 'Built in', feats: ['printer', 'scan', 'battery', 'android'] },
      { k: 'pci', label: 'PCI PTS approval', hint: 'Depends on hardware version', fn: pciCell }
    ] },
    { id: 'screen', title: 'Screen and system', rows: spec(['Display', 'Operating System', 'Processor', 'Memory', 'Keys / Buttons', 'Audio']) },
    { id: 'pay', title: 'Payments and connections', rows: spec(['Card Readers', 'Comms', 'Ports', 'SIM / SAM', 'Printer', 'Cameras / Scanner']) },
    { id: 'build', title: 'Power and build', rows: spec(['Battery', 'Adapter / Power', 'Physical', 'Environmental', 'Accessories']) },
    { id: 'sec', title: 'Security', rows: spec(['Security', 'Certifications']) },
    { id: 'svc', title: 'Allstar services', alwaysShow: true, rows: [
      { k: 'inject', label: 'Key injection', fn: function () { return lines(['Debit PIN key injection: $20 per device', 'Remote key injection (RKI): $35 per device', '190+ processor key sets']); }, needs: false },
      { k: 'ship', label: 'Ships', fn: function () { return lines(['Blank units: same day when ordered by 10 AM CST', 'Injected or programmed: 2 to 3 business days']); }, needs: false },
      { k: 'returns', label: 'Returns', fn: function (it) { return it.sunmi ? lines(['Final sale (SUNMI manufacturer policy)', 'Defects are covered by SUNMI warranty']) : lines(['Injected or programmed units carry a 25% restocking fee']); }, needs: false },
      { k: 'docs', label: 'Documents', fn: docsCell }
    ] }
  ];
  function spec(keys) {
    return keys.map(function (k) {
      return { k: 's:' + k, label: LABELS[k] || k, fn: function (it, sp) {
        var v = sp.rows[k];
        if (!v && sp.rows._combined && (k === 'Memory' || k === 'Operating System')) return { html: '<span class="ast-cell--na">Listed under Processor</span>', key: '~combined' };
        return v ? lines(v.split(/\n|\s\|\s/)) : null;
      } };
    });
  }
  function txt(s) { return { html: esc(s), key: s }; }
  function lines(arr) {
    arr = arr.map(function (s) { return String(s).trim(); }).filter(Boolean);
    return { html: arr.map(function (s) { return '<span class="ast-cell__line">' + esc(s) + '</span>'; }).join(''), key: arr.join('|').toLowerCase() };
  }
  function priceCell(it) {
    var stock = it.avail ? '<span class="ast-cell__tag ast-cell__tag--ok">In stock</span>' : '<span class="ast-cell__tag ast-cell__tag--wait">Ask about stock</span>';
    return { html: '<span class="ast-cell--big">' + (it.varies ? '<span class="ast-cell__sub" style="margin:0 0 2px">From</span>' : '') + money(it.price) + '</span>' + stock + '<span class="ast-cell__sub">Wholesale pricing on quote</span>', key: it.price + '|' + it.avail };
  }
  function pciCell(it, sp) {
    var rows = (pci.d || {})[it.h];
    if (!rows || !rows.length) {
      var m = sp && sp.all && sp.all.match(/approval expire[sd]?\s+(\d{1,2} \w{3} \d{4})/i);
      var v = sp && sp.all && sp.all.match(/PTS\s+(\d\.x)/i);
      if (m) return { html: '<span class="ast-cell__line"><strong>Expires ' + esc(m[1]) + '</strong>' + (v ? ' (PTS ' + esc(v[1]) + ')' : '') + '</span>', key: m[1] };
      return { html: '<span class="ast-cell__line">Ask us to confirm</span><span class="ast-cell__sub">We check the approval number for the exact hardware version.</span>', key: '?' };
    }
    var a = rows.filter(function (r) { return r[2] === 'a'; }), e = rows.filter(function (r) { return r[2] === 'e'; });
    var out = [], key = rows.map(function (r) { return r.join(':'); }).join('|');
    if (a.length) {
      out.push('<span class="ast-cell__line"><strong>' + (a.length > 1 ? 'Newest hardware: expires ' : 'Expires ') + esc(a[0][1]) + '</strong> (PTS ' + esc(a[0][0]) + ')</span>');
      a.slice(1).forEach(function (r) { out.push('<span class="ast-cell__line">Older hardware: expires ' + esc(r[1]) + ' (PTS ' + esc(r[0]) + ')</span>'); });
      if (e.length) out.push('<span class="ast-cell__line">Oldest hardware: expired ' + esc(e[0][1]) + '</span>');
    } else {
      out.push('<span class="ast-cell__line"><strong>Expired ' + esc(e[0][1]) + '</strong> (PTS ' + esc(e[0][0]) + ')</span>');
      out.push('<span class="ast-cell__sub">Still sold. Whether it can be deployed is up to your processor or acquirer.</span>');
    }
    return { html: out.join(''), key: key };
  }
  function docsCell(it, sp) {
    var l = ['<a href="' + esc(it.url) + '">Product page</a>'];
    if (sp && sp.pdf) l.unshift('<a href="' + esc(sp.pdf) + '" target="_blank" rel="noopener">Spec sheet (PDF)</a>');
    return { html: '<span class="ast-cell__links">' + l.join('') + '</span>', key: it.h };
  }
  function featsCell(sp, keys, it) {
    var states = keys.map(function (k) { return feat(sp, k, it); });
    var html = keys.map(function (k, i) {
      var s = states[i], f = FEATS[k];
      var ic = s === 'yes' || s === 'opt' ? icon('check') : s === 'no' ? icon('minus') : '';
      var sr = { yes: 'Yes', opt: 'Optional', no: 'No', unk: 'Not listed by the manufacturer' }[s];
      return '<span class="ast-feat ast-feat--' + s + '" title="' + sr + '"><span class="ast-feat__i" aria-hidden="true">' + ic + '</span>' + esc(f.label) +
        (s === 'opt' ? ' <em>opt.</em>' : '') + '<span class="visually-hidden">: ' + sr + '</span></span>';
    }).join('');
    return { html: '<span class="ast-feats">' + html + '</span>', key: states.join(',') };
  }

  /* ---------- State ---------- */
  var sel = [], offset = 0, diffOnly = false, closed = {}, pickerTarget = null, filt = { q: '', type: '', brand: '' };
  function fromURL() {
    var p = new URLSearchParams(location.search);
    var d = (p.get('d') || p.get('devices') || '').split(',').filter(function (h) { return byH[h]; });
    if (!d.length) { try { d = JSON.parse(sessionStorage.getItem('ast-cmp-sel') || '[]').filter(function (h) { return byH[h]; }); } catch (e) {} }
    sel = d.slice(0, MAX);
  }
  function toURL() {
    var p = new URLSearchParams(location.search);
    if (sel.length) p.set('d', sel.join(',')); else p.delete('d');
    p.delete('devices');
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    try { sessionStorage.setItem('ast-cmp-sel', JSON.stringify(sel)); } catch (e) {}
  }
  function setSel(next, opts) {
    var before = sel.join();
    sel = next.filter(function (h, i) { return byH[h] && next.indexOf(h) === i; }).slice(0, MAX);
    if (offset > Math.max(0, sel.length - 2)) offset = Math.max(0, sel.length - 2);
    sel.forEach(load);
    toURL();
    render(opts);
    if (sel.join() !== before) track();
  }
  var tracked = {};
  function track() {
    if (sel.length < 2 || tracked[sel.join()]) return;
    tracked[sel.join()] = 1;
    if (typeof window.gtag === 'function') window.gtag('event', 'compare_devices', { devices: sel.map(function (h) { return byH[h].model; }).join(' | '), device_count: sel.length });
  }

  /* ---------- Render ---------- */
  var tray = $('[data-ast-tray]'), slotsEl = $('[data-ast-slots]'), table = $('[data-ast-table]'), empty = $('[data-ast-empty]');
  var lastCols = '';
  function visible() {
    if (!mqPhone.matches) return sel.slice();
    return sel.slice(offset, offset + 2);
  }
  function colCount() { return mqPhone.matches ? 2 : MAX; }

  function render(opts) {
    opts = opts || {};
    var vis = visible(), n = colCount();
    var cols = []; for (var i = 0; i < n; i++) cols.push(vis[i] || null);
    var colsKey = cols.join(',');
    var fresh = colsKey !== lastCols; lastCols = colsKey;

    // Count and tools
    $('[data-ast-count]').textContent = sel.length ? 'Comparing ' + sel.length + ' of ' + MAX + ' devices' : 'Pick up to ' + MAX + ' devices';
    $('[data-ast-clear]').disabled = !sel.length;
    $('[data-ast-share]').disabled = sel.length < 2;
    $$('[data-ast-quote]').forEach(function (a) { a.setAttribute('aria-disabled', sel.length ? 'false' : 'true'); });

    // Slots
    slotsEl.innerHTML = cols.map(function (h, i) {
      if (!h) {
        var canAdd = sel.length < MAX;
        return '<button type="button" class="ast-slot ast-slot--empty" data-ast-add="' + (offset + i) + '"' + (canAdd ? '' : ' disabled') + '><span class="ast-slot__plus">' + icon('plus') + '</span><span>' + (sel.length ? 'Add a device' : 'Add a device') + '</span></button>';
      }
      var it = byH[h];
      return '<div class="ast-slot ast-slot--filled' + (fresh && !reduceMotion ? ' ast-cmp__fresh' : '') + '">' +
        '<div class="ast-slot__media">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" width="240" height="240" loading="lazy">' : '') + '</div>' +
        '<div class="ast-slot__body"><div class="ast-slot__brand">' + esc(it.brand) + (it.refurb ? ' · Refurbished' : '') + '</div>' +
        '<a class="ast-slot__name" href="' + esc(it.url) + '" title="' + esc(it.model) + '">' + esc(it.short) + '</a>' +
        '<div class="ast-slot__meta"><span class="ast-slot__price">' + (it.varies ? 'From ' : '') + money(it.price) + '</span><span>' + esc(typeLabel(it)) + '</span></div>' +
        '<button type="button" class="ast-cmp__link ast-slot__swap" data-ast-swap="' + esc(h) + '">Change</button></div>' +
        '<button type="button" class="ast-slot__x" data-ast-remove="' + esc(h) + '" aria-label="Remove ' + esc(it.model) + '">' + icon('close') + '</button></div>';
    }).join('');

    // Pager (phones only)
    var pager = $('[data-ast-pager]');
    var showPager = mqPhone.matches && sel.length > 2;
    pager.hidden = !showPager;
    if (showPager) {
      $('[data-ast-page-label]').textContent = (offset + 1) + '-' + Math.min(offset + 2, sel.length) + ' of ' + sel.length;
      $('[data-ast-page="-1"]').disabled = offset === 0;
      $('[data-ast-page="1"]').disabled = offset + 2 >= sel.length;
    }

    // Empty vs table
    var has = sel.length > 0;
    root.classList.toggle('has-sel', has);
    if (!has) setStuck(false);
    empty.hidden = has;
    var inl = $('[data-ast-presets-inline]'); if (inl && presets.length) inl.hidden = !has;
    table.hidden = !has;
    $('[data-ast-cta]').hidden = !has;
    mbar.classList.toggle('is-on', has);
    if (!has) { table.innerHTML = ''; return; }

    // Table
    var html = '';
    GROUPS.forEach(function (g) {
      var rowsHtml = '', shown = 0, same = 0;
      g.rows.forEach(function (r) {
        var vals = cols.map(function (h) {
          if (!h) return { empty: true };
          var it = byH[h], sp = specs[h];
          var needs = r.needs !== false;
          if (needs && (!sp || sp.state === 'loading')) return { loading: true };
          if (needs && sp.state === 'error') return { error: true, h: h };
          var v = r.feats ? featsCell(sp, r.feats, it) : r.fn(it, sp || null);
          return v || { na: true };
        });
        var real = vals.filter(function (v) { return !v.empty; });
        if (!real.length) return;
        if (real.every(function (v) { return v.na; })) return;
        var ready = real.every(function (v) { return v.key != null || v.na; });
        var isSame = ready && real.length > 1 && real.every(function (v) { return (v.key || '∅') === (real[0].key || '∅'); });
        shown++; if (isSame) same++;
        rowsHtml += '<div class="ast-row ast-cmp__grid' + (isSame ? ' is-same' : '') + '" role="row">' +
          '<div class="ast-row__label" role="rowheader">' + esc(r.label) + (r.hint ? '<span class="ast-row__hint">' + esc(r.hint) + '</span>' : '') + '</div>' +
          '<div class="ast-cmp__cells">' + vals.map(function (v) {
            var inner;
            if (v.empty) inner = '';
            else if (v.loading) inner = '<span class="ast-skel"></span><span class="ast-skel"></span>';
            else if (v.error) inner = '<span class="ast-cell--na">Could not load. <button type="button" class="ast-retry" data-ast-retry="' + esc(v.h) + '">Try again</button></span>';
            else if (v.na) inner = '<span class="ast-cell--na">Not listed</span>';
            else inner = v.html;
            return '<div class="ast-cell" role="cell">' + inner + '</div>';
          }).join('') + '</div></div>';
      });
      if (!shown) return;
      var open = !closed[g.id];
      html += '<div class="ast-grp' + (same === shown && !g.alwaysShow ? ' is-all-same' : '') + '" role="rowgroup">' +
        '<button type="button" class="ast-grp__head" aria-expanded="' + open + '" data-ast-grp="' + g.id + '"><h3 class="ast-grp__title">' + esc(g.title) + '</h3>' +
        '<span class="ast-grp__count">' + (sel.length > 1 && same ? (shown - same) + ' of ' + shown + ' differ' : shown + ' rows') + '</span><span class="ast-grp__chev" aria-hidden="true"></span></button>' +
        '<div class="ast-grp__rows"' + (open ? '' : ' hidden') + '>' + (g.id === 'glance' ? '<p class="ast-legend"><span class="ast-feat ast-feat--yes"><span class="ast-feat__i">' + icon('check') + '</span>Yes</span><span class="ast-feat ast-feat--no"><span class="ast-feat__i">' + icon('minus') + '</span>No</span><span class="ast-feat ast-feat--unk"><span class="ast-feat__i"></span>Not listed by the manufacturer</span></p>' : '') + rowsHtml + '</div></div>';
    });
    table.innerHTML = html;
    if (fresh && !reduceMotion && !opts.quiet) table.classList.add('ast-cmp__fresh'), setTimeout(function () { table.classList.remove('ast-cmp__fresh'); }, 500);
    syncQuote();
  }

  /* ---------- Presets (empty state) ---------- */
  function renderPresets() {
    var grid = $('[data-ast-preset-grid]');
    if (!presets.length) { grid.hidden = true; $('[data-ast-presets-inline]') && ($('[data-ast-presets-inline]').hidden = true); return; }
    grid.innerHTML = presets.map(function (p, i) {
      var its = p.h.map(function (h) { return byH[h]; });
      return '<button type="button" class="ast-pre" data-ast-preset="' + i + '"><span><p class="ast-pre__title">' + esc(p.label) + '</p>' +
        '<p class="ast-pre__names">' + esc(p.note || its.map(function (x) { return x.model; }).join(', ')) + '</p>' +
        '<span class="ast-pre__thumbs">' + its.map(function (x) { return '<span class="ast-pre__thumb">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="54" height="54">' : '') + '</span>'; }).join('') + '</span></span>' +
        '<span class="ast-pre__go">Compare</span></button>';
    }).join('');
  }

  /* ---------- Picker ---------- */
  var dlg = $('[data-ast-picker]'), results = $('[data-ast-pk-results]'), qInput = $('[data-ast-pk-q]');
  var pending = [];
  function openPicker(target) {
    pickerTarget = target;
    pending = sel.slice();
    renderChips(); renderResults();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    if (!mqPhone.matches) setTimeout(function () { qInput.focus(); }, 30);
  }
  function closePicker(apply) {
    if (apply) {
      setSel(pending);
      if (pending.length && mqPhone.matches && pickerTarget && pickerTarget.slot != null) offset = Math.max(0, Math.min(pickerTarget.slot, pending.length - 2)), render();
    }
    if (dlg.open) dlg.close(); else dlg.removeAttribute('open');
  }
  function matches(it, ignore) {
    if (filt.q) { var ok = filt.q.toLowerCase().split(/\s+/).every(function (w) { return it.q.indexOf(w) > -1; }); if (!ok) return false; }
    if (ignore !== 'type' && filt.type && it.types.indexOf(filt.type) < 0) return false;
    if (ignore !== 'brand' && filt.brand && it.brand !== filt.brand) return false;
    return true;
  }
  function renderChips() {
    var tc = {}, bc = {};
    items.forEach(function (it) {
      if (matches(it, 'type')) it.types.forEach(function (t) { tc[t] = (tc[t] || 0) + 1; });
      if (matches(it, 'brand')) bc[it.brand] = (bc[it.brand] || 0) + 1;
    });
    $('[data-ast-pk-types]').innerHTML = '<button type="button" class="ast-cmp__chip" data-ast-type="" aria-pressed="' + !filt.type + '">All types</button>' +
      TYPES.filter(function (t) { return tc[t[0]] || filt.type === t[0]; }).map(function (t) {
        return '<button type="button" class="ast-cmp__chip" data-ast-type="' + t[0] + '" aria-pressed="' + (filt.type === t[0]) + '">' + t[1] + '<small>' + (tc[t[0]] || 0) + '</small></button>';
      }).join('');
    var brands = BRAND_ORDER.concat(Object.keys(bc).filter(function (b) { return BRAND_ORDER.indexOf(b) < 0; }));
    $('[data-ast-pk-brands]').innerHTML = '<button type="button" class="ast-cmp__chip" data-ast-brand="" aria-pressed="' + !filt.brand + '">All brands</button>' +
      brands.filter(function (b) { return bc[b] || filt.brand === b; }).map(function (b) {
        return '<button type="button" class="ast-cmp__chip" data-ast-brand="' + esc(b) + '" aria-pressed="' + (filt.brand === b) + '">' + esc(b) + '<small>' + (bc[b] || 0) + '</small></button>';
      }).join('');
  }
  function renderResults() {
    var list = items.filter(function (it) { return matches(it); });
    var full = pending.length >= MAX;
    $('[data-ast-pk-sub]').textContent = pending.length + ' of ' + MAX + ' selected';
    $('[data-ast-pk-note]').textContent = full ? 'Comparison is full. Remove one to add another.' : list.length + (list.length === 1 ? ' device' : ' devices');
    if (!list.length) {
      results.innerHTML = '<div class="ast-pk__none"><p>No devices match.</p><button type="button" class="ast-cmp__link" data-ast-reset>Clear search and filters</button></div>';
      return;
    }
    var html = '', cur = null, buf = [], count = 0;
    function flush() { if (cur !== null) html += '<h3 class="ast-pk__brand">' + esc(cur) + ' <span>' + count + '</span></h3><div class="ast-pk__grid">' + buf.join('') + '</div>'; buf = []; count = 0; }
    list.forEach(function (it) {
      if (it.brand !== cur) { flush(); cur = it.brand; }
      var on = pending.indexOf(it.h) > -1, dis = !on && full;
      count++;
      buf.push('<button type="button" class="ast-opt" data-ast-pick="' + esc(it.h) + '" aria-pressed="' + on + '"' + (dis ? ' aria-disabled="true"' : '') + '>' +
        (it.refurb || it.limited ? '<span class="ast-opt__flag">' + [it.refurb ? 'Refurbished' : '', it.limited ? 'Limited specs' : ''].filter(Boolean).join(', ') + '</span>' : '') +
        '<span class="ast-opt__check" aria-hidden="true">' + icon('check') + '</span>' +
        '<span class="ast-opt__media">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy" width="200" height="200">' : '') + '</span>' +
        '<span class="ast-opt__name">' + esc(it.short) + '</span>' +
        '<span class="ast-opt__meta"><span>' + esc(typeLabel(it)) + '</span><b>' + money(it.price) + '</b></span></button>');
    });
    flush();
    results.innerHTML = html;
  }

  /* ---------- Quote hand-off ---------- */
  var PREFILL_MARK = '__ x ';
  function syncQuote() {
    var ta = document.getElementById('AstWQ-devices');
    if (!ta) return;
    var cur = ta.value.trim();
    var ours = !cur || cur.split('\n').every(function (l) { return l.indexOf(PREFILL_MARK) === 0; });
    if (ours) ta.value = sel.map(function (h) { return PREFILL_MARK + byH[h].model; }).join('\n');
    var form = ta.form, hid = form && form.querySelector('[name="contact[Form]"]');
    if (hid) hid.value = 'Wholesale quote request (compare page)';
  }
  function goQuote(e) {
    var target = document.getElementById('quote');
    if (!target) return;
    e.preventDefault();
    syncQuote();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    var ta = document.getElementById('AstWQ-devices');
    setTimeout(function () { var first = document.getElementById('AstWQ-name'); if (first && !first.value) first.focus({ preventScroll: true }); }, reduceMotion ? 0 : 600);
    if (ta) ta.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ---------- Toast ---------- */
  var toastEl = $('[data-ast-toast]'), toastT;
  function toast(msg) { toastEl.textContent = msg; toastEl.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200); }

  /* ---------- Mobile action bar ---------- */
  var mbar = document.createElement('div');
  mbar.className = 'ast-cmp__mbar';
  mbar.innerHTML = '<button type="button" class="ast-cmp__btn" data-ast-open>Add device</button><a href="#quote" class="ast-cmp__btn ast-cmp__btn--pri" data-ast-quote>Get a quote</a>';
  root.appendChild(mbar);

  /* ---------- Events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, a');
    if (!t || !root.contains(t)) return;
    var d = t.dataset;
    if (d.astAdd != null) openPicker({ slot: +d.astAdd });
    else if (t.hasAttribute('data-ast-open')) openPicker(null);
    else if (d.astSwap) { openPicker({ swap: d.astSwap }); }
    else if (d.astRemove) setSel(sel.filter(function (h) { return h !== d.astRemove; }));
    else if (d.astPreset != null) { var p = presets[+d.astPreset]; if (p) { offset = 0; setSel(p.h); $('[data-ast-sentinel]').scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); } }
    else if (t.hasAttribute('data-ast-clear')) { setSel([]); }
    else if (t.hasAttribute('data-ast-share')) {
      var url = location.origin + location.pathname + '?d=' + sel.join(',');
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { toast('Link copied. Anyone with it sees this comparison.'); }, function () { window.prompt('Copy this link', url); });
    }
    else if (d.astPage) { offset = Math.max(0, Math.min(sel.length - 2, offset + (+d.astPage))); render(); }
    else if (d.astGrp) { closed[d.astGrp] = !closed[d.astGrp]; var open = !closed[d.astGrp]; t.setAttribute('aria-expanded', open); t.nextElementSibling.hidden = !open; }
    else if (d.astRetry) { delete specs[d.astRetry]; load(d.astRetry); render({ quiet: true }); }
    else if (t.hasAttribute('data-ast-quote')) { if (!sel.length) { e.preventDefault(); return; } goQuote(e); }
    else if (d.astPick) {
      if (t.getAttribute('aria-disabled') === 'true') return;
      var h = d.astPick, i = pending.indexOf(h);
      if (pickerTarget && pickerTarget.swap) {
        var at = pending.indexOf(pickerTarget.swap);
        if (i > -1 && h !== pickerTarget.swap) { pending.splice(i, 1); at = pending.indexOf(pickerTarget.swap); }
        if (at > -1) pending[at] = h; else pending.push(h);
        closePicker(true); return;
      }
      if (i > -1) pending.splice(i, 1);
      else if (pending.length < MAX) {
        if (pickerTarget && pickerTarget.slot != null && pickerTarget.slot < pending.length) pending.splice(pickerTarget.slot, 0, h); else pending.push(h);
      }
      renderResults();
    }
    else if (d.astType != null) { filt.type = d.astType; renderChips(); renderResults(); }
    else if (d.astBrand != null) { filt.brand = d.astBrand; renderChips(); renderResults(); }
    else if (t.hasAttribute('data-ast-reset')) { filt = { q: '', type: '', brand: '' }; qInput.value = ''; renderChips(); renderResults(); }
    else if (t.hasAttribute('data-ast-pk-done')) closePicker(true);
    else if (t.hasAttribute('data-ast-pk-close')) closePicker(false);
  });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) closePicker(false); });
  dlg.addEventListener('cancel', function () { pending = sel.slice(); });
  var qT;
  qInput.addEventListener('input', function () { clearTimeout(qT); qT = setTimeout(function () { filt.q = qInput.value.trim(); renderChips(); renderResults(); results.scrollTop = 0; }, 90); });
  qInput.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    var first = results.querySelector('.ast-opt:not([aria-disabled="true"])');
    if (first) first.click();
  });
  $('[data-ast-diff]').addEventListener('change', function (e) { diffOnly = e.target.checked; root.classList.toggle('is-diff', diffOnly); });
  (mqPhone.addEventListener ? mqPhone.addEventListener.bind(mqPhone, 'change') : mqPhone.addListener.bind(mqPhone))(function () { offset = 0; lastCols = ''; render({ quiet: true }); });

  // Tray: sit under the theme's sticky header (it hides and reappears) and condense once stuck.
  var hdr = document.querySelector('.shopify-section-header');
  function setTop() {
    var b = 0;
    if (hdr) {
      var pos = getComputedStyle(hdr).position;
      if (pos === 'sticky' || pos === 'fixed') b = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
    }
    root.style.setProperty('--top', b + 'px');
  }
  // Condensing changes the tray height. Pad the difference back so the page height stays
  // the same; otherwise scroll anchoring shifts the page and the tray flips back and forth.
  function setStuck(stuck) {
    if (!root.classList.contains('has-sel')) stuck = false;
    if (tray.classList.contains('is-stuck') === stuck) return;
    var before = tray.offsetHeight;
    tray.style.marginBottom = '0px';
    tray.classList.toggle('is-stuck', stuck);
    var after = tray.offsetHeight;
    tray.style.marginBottom = stuck ? Math.max(0, before - after) + 'px' : '0px';
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      setStuck(!en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      setTop();
    }, { threshold: [0, 1] });
    io.observe($('[data-ast-sentinel]'));
    if (hdr) {
      var th = []; for (var k = 0; k <= 20; k++) th.push(k / 20);
      new IntersectionObserver(setTop, { threshold: th }).observe(hdr);
      if ('MutationObserver' in window) new MutationObserver(function () { requestAnimationFrame(setTop); setTimeout(setTop, 350); }).observe(hdr, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
    }
  }
  setTop();

  /* ---------- Boot ---------- */
  var totalEl = $('[data-ast-total]'); if (totalEl) totalEl.textContent = items.length;
  var pd = $('[data-ast-pci-date]'); if (pd) pd.textContent = pci.pulled ? new Date(pci.pulled + 'T12:00:00').toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' }) : 'quarterly';
  renderPresets();
  fromURL();
  sel.forEach(load);
  render({ quiet: true });
  if (location.search.indexOf('contact_posted=true') > -1) { var q = document.getElementById('quote'); if (q) q.scrollIntoView(); }
})();
